import { IRelatedProductUsecase } from '@modules/products/domain/ports/getRelatedProduct.usecase.port';
import { left, right } from '@shared/utils/either.utils';
import { shuffleArrayWithLimitOutput } from '@shared/utils/random.utils';
import { IProductRelatedProductRepository } from '../ports/relatedProduct.repository.port';
export class GetProductRelatedProductUsecase implements IRelatedProductUsecase {
  constructor(private readonly productRelatedProductRepository: IProductRelatedProductRepository) {}
  async handle(productId: number, isLoggedIn: boolean): IRelatedProductUsecase.getRelatedProductOutput {
    const result = isLoggedIn ? await this.productRelatedProductRepository.getRelatedProductWithPersonalized(productId) : await this.productRelatedProductRepository.getRelatedProduct(productId);
    const value = result.value;
    if (result.isLeft()) return left([]);
    const output = shuffleArrayWithLimitOutput(value, 4);
    return right(output);
  }
}